<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()

onMounted(() => {
  // Si ya está autenticado, redirigir al dashboard
  if (authStore.isAuthenticated) {
    router.push({ name: authStore.canAccessDashboard ? 'dashboard' : 'quotes.index' })
  }
})
</script>

<template>
  <div class="min-h-screen bg-surface-50 dark:bg-surface-950 flex items-center justify-center px-4 py-12">
    <div class="w-full max-w-md">
      <slot />
    </div>
  </div>
</template>

<style scoped>
/* Animación de entrada */
.animate-fade-in {
  animation: fade-in 0.3s ease-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>